<template>
	<div id="app" v-if="isRouterAlive">
		<router-view></router-view>
	</div>
</template>
<script>
	import config from '../configHttp.js'
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload //  声明一个变量
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		mounted() {
			var params = ''
			if (location.href.indexOf('?') != -1) {
				params = '?' + location.href.substring(location.href.indexOf('?')).substr(1);
			}
			if (this._isMobile()) {
				location.href = config.mobileUrl + params
			}
			window.onresize = () => {
				return (() => {
					if (this._isMobile()) {
						location.href = config.mobileUrl + params
					}
				})()
			}
		},
		created() {
			// this.$router.beforeEach((to, from, next) => {
			// 	var routearr = localStorage.getItem('meaurouter');
			// 	if (to.path == '/login' || from.path == '/login' || to.path == '/homepage') {
			// 		next();
			// 	} else {
			// 		var userInfo = localStorage.getItem('userInfo');
			// 		if (!userInfo) {
			// 			localStorage.clear();
			// 			router.push('/login');
			// 		}
			// 		if ((routearr.indexOf(to.meta.roles[0])) == -1) {
			// 			next(from.path);
			// 		} else {
			// 			next();
			// 		}
			// 	}
			// });
		},
		methods: {
			_isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)
				return flag;
			},
			reload() {
				// 通过 this.isRouterAlive 控制 router-view 达到刷新效果
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
			}
		}
	};
</script>
<style>
	@import "./assets/css/main.css";
</style>